export default "__VITE_ASSET__DcQJpQNN__"